module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-concombre.6e321b93.jpg";